import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import pcs from "../../assets/images/pcs_logo.png"
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { Link, withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { decryptData } from "services/encription_service"

const genralReports = [
  {
    url: "/reports/orders",
    title: "Orders Report",
  },
  {
    url: "/reports/orderforms",
    title: "Orderform Report",
  },
  {
    url: "/reports/proforma",
    title: "Proforma Reports",
  },
  {
    url: "/reports/invoices",
    title: "Invoice Report",
  },
  {
    url: "/reports/payroll",
    title: "Payroll Report",
  },
  {
    url: "/reports/wnotification",
    title: "WhatsApp Report",
  },
  {
    url: "/reports/no-order-clinets",
    title: "No Order Clinets",
  },
  {
    url: "/reports/lmsd-report",
    title: "LMSD Reports",
  },
  {
    url: "/reports/genrated-invoices",
    title: "Genrated Invoices",
  },
  {
    url: "/reports/invoice-summary",
    title: "Invoice Sumary",
  },
]

const analyticReports = [
  {
    url: "",
    title: "Analyse Reports",
  },
  {
    url: "",
    title: "Day wise Dispatch",
  },
  {
    url: "",
    title: "Daily Analyse",
  },
  {
    url: "",
    title: "Monthly Analyse",
  },
  {
    url: "",
    title: "MA For Stations",
  },
  {
    url: "",
    title: "Monthly Productivity",
  },
  {
    url: "",
    title: "Product Analyze",
  },
  {
    url: "",
    title: "Doctor Ranking",
  },
  {
    url: "",
    title: "Source Wise Reports",
  },
  {
    url: "",
    title: "BenchMark Reports",
  },
]

const SidebarContent = props => {
  const ref = useRef()
  const [isAdmin, setIsAdmin] = useState(false)
  const [userModules, setUserModules] = useState(false)

  useEffect(() => {
    let isMounted = true
    const loadUserData = async () => {
      try {
        const state = JSON.parse(localStorage.getItem("authUser")) || {}

        if (state.user_role == "owner") {
          if (isMounted) setIsAdmin("owner")
        } else if (state.role == "Superadmin") {
          if (isMounted) {
            setIsAdmin("superadmin")
            // Inject synthetic full permissions so the existing dynamic menu
            // rendering paths (hasOwnProperty checks) work for Superadmin
            // without duplicating any JSX. Admin/user flow is untouched.
            setUserModules({
              masters: {
                department: { read: true },
                designation: { read: true },
                lab_department: { read: true },
                countries: { read: true },
                state: { read: true },
                cities: { read: true },
                stations: { read: true },
                zones: { read: true },
                source: { read: true },
                qualification: { read: true },
                correction_template: { read: true },
                locations: { read: true },
              },
              job_master: {
                shade_guide: { read: true },
                shade: { read: true },
              },
              product_master: {
                products: { read: true },
                product_category: { read: true },
                product_warrenty: { read: true },
                product_type: { read: true },
                product_group: { read: true },
              },
              employee_master: {
                employees: { read: true },
              },
              client_master: {
                client: { read: true },
                blocked_client: { read: true },
                priority: { read: true },
                parents: { read: true },
              },
              orders: { orders: { read: true } },
              challans: { challans: { read: true } },
              invoice: { invoices: { add: true, read: true, edit: true }, proforma: { read: true } },
              reports: { all: true },
            })
          }
          return // skip reading encrypted userdetails for Superadmin
        } else if (state.role == "Admin") {
          if (isMounted) setIsAdmin("admin")
        }

        const rawUserdetails = localStorage.getItem("userdetails")
        if (!rawUserdetails) return
        const modules = await decryptData(rawUserdetails)

        let menus = {}
        if (modules) {
          if (typeof modules === "string") {
            try {
              menus = JSON.parse(modules)
              if (typeof menus === "string") {
                menus = JSON.parse(menus)
              }
            } catch (e) { }
          } else {
            menus = modules
          }
        }

        const filteredData = {}
        for (const key in menus) {
          if (menus.hasOwnProperty(key)) {
            filteredData[key] = Object.fromEntries(
              Object.entries(menus[key]).filter(([subKey, value]) =>
                Object.values(value).includes(true)
              )
            )
          }
        }
        if (isMounted) {
          setUserModules(filteredData)
        }
      } catch (e) {
        console.error("Sidebar user data load error:", e)
      }
    }
    loadUserData()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (userModules) {
      ref.current.recalculate()
      const pathName = props.location.pathname

      const initMenu = () => {
        new MetisMenu("#side-menu")
        let matchingMenuItem = null
        const ul = document.getElementById("side-menu")
        const items = ul.getElementsByTagName("a")
        for (let i = 0; i < items.length; ++i) {
          if (pathName === items[i].pathname) {
            matchingMenuItem = items[i]
            break
          }
        }
        if (matchingMenuItem) {
          activateParentDropdown(matchingMenuItem)
        }
      }
      initMenu()
      localStorage.setItem("menus", JSON.stringify(userModules))
    }
  }, [userModules])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  const isAdministrativeUser = typeof isAdmin === "string" && ["admin", "superadmin", "owner"].includes(isAdmin.toLowerCase());

  const hasMasters = isAdministrativeUser ||
    Boolean(userModules?.hasOwnProperty("masters")) ||
    Boolean(userModules?.hasOwnProperty("job_master")) ||
    Boolean(userModules?.hasOwnProperty("product_master")) ||
    Boolean(userModules?.hasOwnProperty("employee_master")) ||
    Boolean(userModules?.hasOwnProperty("client_master"));

  const hasActivity = Boolean(userModules?.hasOwnProperty("orders")) || Boolean(userModules?.hasOwnProperty("challans"));

  const hasAccounts = isAdministrativeUser || (
    Boolean(userModules?.hasOwnProperty("invoice")) &&
    Boolean(userModules?.invoice?.invoices?.add || userModules?.invoice?.invoices?.read || userModules?.invoice?.invoices?.all || userModules?.invoice?.invoices?.edit)
  );

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            {hasMasters && <li className="menu-title">{props.t("Masters")}</li>}

            {isAdmin == "owner" && (
              <>
                <li>
                  <Link to="/company">{props.t("Company")}</Link>
                </li>
                <li>
                  <Link to="/audit-logs">
                    <i className="bx bx-history"></i>
                    <span>{props.t("Audit Logs")}</span>
                  </Link>
                </li>
              </>
            )}

            {isAdmin == "superadmin" && (
              <>
                {/* Superadmin-exclusive items not in the role permission matrix */}
                <li>
                  <Link to="/branches">
                    <i className="bx bx-building-house"></i>
                    <span>{props.t("Branchs")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/roles">
                    <i className="bx bx-shield-alt-2"></i>
                    <span>{props.t("Roles")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/audit-logs">
                    <i className="bx bx-history"></i>
                    <span>{props.t("Audit Logs")}</span>
                  </Link>
                </li>
              </>
            )}

            {userModules?.hasOwnProperty("masters") && (
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bx-layout"></i>
                  <span>{props.t("Masters")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {userModules?.masters?.hasOwnProperty("department") && (
                    <li>
                      <Link to="/department">{props.t("Department")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("designation") && (
                    <li>
                      <Link to="/designation">{props.t("Designation")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("lab_department") && (
                    <li>
                      <Link to="/lab-department">
                        {props.t("Lab Department")}
                      </Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("countries") && (
                    <li>
                      <Link to="/countries">{props.t("Countries")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("state") && (
                    <li>
                      <Link to="/states">{props.t("State")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("cities") && (
                    <li>
                      <Link to="/cities">{props.t("Cities")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("stations") && (
                    <li>
                      <Link to="/stations">{props.t("Stations")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("zones") && (
                    <li>
                      <Link to="/zones">{props.t("Zones")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("source") && (
                    <li>
                      <Link to="/source">{props.t("Source")}</Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty("qualification") && (
                    <li>
                      <Link to="/qualifications">
                        {props.t("Qualifications")}
                      </Link>
                    </li>
                  )}

                  {userModules?.masters?.hasOwnProperty(
                    "correction_template"
                  ) && (
                      <li>
                        <Link to="/correction-template">
                          {props.t("Correction Template")}
                        </Link>
                      </li>
                    )}
                  {userModules?.masters?.hasOwnProperty("locations") && (
                    <li>
                      <Link to="/locations">{props.t("Locations")}</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {userModules?.hasOwnProperty("job_master") && (
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bx-barcode"></i>
                  <span>{props.t("Job Master")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {userModules?.job_master?.hasOwnProperty("shade_guide") && (
                    <li>
                      <Link to="/Job/shade-guide">
                        {props.t("Shade Guide")}
                      </Link>
                    </li>
                  )}
                  {userModules?.job_master?.hasOwnProperty("shade") && (
                    <li>
                      <Link to="/Job/shade">{props.t("Shade")}</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {userModules?.hasOwnProperty("product_master") && (
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bx-cart-alt"></i>
                  <span>{props.t("Product Master")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {userModules?.product_master?.hasOwnProperty("product_category") && (
                    <li><Link to="/product/category">{props.t("Category")}</Link></li>
                  )}
                  {userModules?.product_master?.hasOwnProperty("product_type") && (
                    <li><Link to="/product/type">{props.t("Type")}</Link></li>
                  )}
                  {userModules?.product_master?.hasOwnProperty("products") && (
                    <li><Link to="/products">{props.t("Products")}</Link></li>
                  )}
                  {userModules?.product_master?.hasOwnProperty("product_warrenty") && (
                    <li><Link to="/product/warranty">{props.t("Warranty")}</Link></li>
                  )}
                </ul>
              </li>
            )}

            {userModules?.hasOwnProperty("employee_master") && (
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bx-user-circle"></i>
                  <span>{props.t("Employee Master")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {userModules?.employee_master?.hasOwnProperty("employees") && (
                    <>
                      <li><Link to="/employees">{props.t("Employees")}</Link></li>
                      <li><Link to="/hrms/attendance">{props.t("Attendance")}</Link></li>
                      <li><Link to="/hrms/leaves">{props.t("Leaves")}</Link></li>
                      <li><Link to="/hrms/shifts">{props.t("Shifts")}</Link></li>
                      <li><Link to="/hrms/assets">{props.t("Assets")}</Link></li>
                      <li><Link to="/hrms/payroll">{props.t("Payroll")}</Link></li>
                      <li><Link to="/hrms/payroll-setup">{props.t("Payroll Setup")}</Link></li>
                    </>
                  )}
                </ul>
              </li>
            )}

            {userModules?.hasOwnProperty("client_master") && (
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bxs-group"></i>
                  <span>{props.t("Client Master")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {userModules?.client_master?.hasOwnProperty("parents") && (
                    <li><Link to="/client/parents">{props.t("Parents")}</Link></li>
                  )}
                  {userModules?.client_master?.hasOwnProperty("client") && (
                    <li><Link to="/clients">{props.t("Clients")}</Link></li>
                  )}
                  {userModules?.client_master?.hasOwnProperty("blocked_client") && (
                    <li><Link to="/clients/blocked">{props.t("Blocked Clients")}</Link></li>
                  )}
                </ul>
              </li>
            )}

            {hasActivity && <li className="menu-title">{props.t("Activity")}</li>}

            {userModules?.hasOwnProperty("orders") && (
              <>
                <li>
                  <Link to="/orders">
                    <i className="bx bx-package"></i>
                    <span>{props.t("Orders")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/process/maptry">
                    <i className="bx bx-shield-quarter"></i>
                    <span>{props.t("Try Map")}</span>
                  </Link>
                </li>
              </>
            )}

            {userModules?.hasOwnProperty("challans") && (
              <>
                <li>
                  <Link to="/orderform/create">
                    <i className="bx bx-copy-alt"></i>
                    <span>{props.t("Create OrderForm")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/orderforms">
                    <i className="bx bx-copy-alt"></i>
                    <span>{props.t("OrderForms")}</span>
                  </Link>
                </li>
              </>
            )}
            {userModules?.hasOwnProperty("challans") && (
              <li>
                <Link to="/challans">
                  <i className="fab fa-wpforms"></i>
                  <span>{props.t("Challans")}</span>
                </Link>
              </li>
            )}

            {hasAccounts && (
              <>
                <li className="menu-title">{props.t("Accounts")}</li>

                {(userModules?.invoice?.invoices?.add || isAdministrativeUser) && (
                  <li>
                    <Link to="/invoices/create">
                      <i className="bx bx-analyse"></i>
                      <span>{props.t("Create Invoice")}</span>
                    </Link>
                  </li>
                )}
                {(userModules?.invoice?.invoices?.add || isAdministrativeUser) && (
                  <li>
                    <Link to="/invoices/proforma">
                      <i className="bx bxs-file-blank"></i>
                      <span>{props.t("Proforma invoices")}</span>
                    </Link>
                  </li>
                )}
                {(userModules?.invoice?.invoices?.add || isAdministrativeUser) && (
                  <li>
                    <Link to="/invoices">
                      <i className="bx bxs-file-pdf"></i>
                      <span>{props.t("Commercial Invoices")}</span>
                    </Link>
                  </li>
                )}
                {(userModules?.invoice?.invoices?.add || isAdministrativeUser) && (
                  <li>
                    <Link to="/warranty-card">
                      <i className="bx bx-id-card"></i>
                      <span>{props.t("Issue WarrantyCard")}</span>
                    </Link>
                  </li>
                )}
              </>
            )}

            {/* {(userModules?.hasOwnProperty('invoice')) && */}
            {(isAdmin == "superadmin" ||
              isAdmin == "admin" ||
              isAdmin == "owner") && (
                <>
                  <li className="menu-title">{props.t("Process Flow")}</li>
                  <li>
                    <Link to="/process/config">
                      <i className="bx bx-analyse"></i>
                      <span>{props.t("Flow Configration")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/process/maptry">
                      <i className="bx bx-shield-quarter"></i>
                      <span>{props.t("Try Map")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/process/live">
                      <i className="fas fa-cloud-download-alt"></i>
                      <span>{props.t("Live panel")}</span>
                    </Link>
                  </li>

                  {userModules?.hasOwnProperty("reports") && (
                    <>
                      <li className="menu-title">{props.t("Reports")}</li>
                      <li><Link to="/reports/orders"><i className="bx bx-doughnut-chart"></i><span>{props.t("Orders Report")}</span></Link></li>
                      <li><Link to="/reports/orderforms"><i className="bx bx-doughnut-chart"></i><span>{props.t("Orderform Report")}</span></Link></li>
                      <li><Link to="/reports/proforma"><i className="bx bx-doughnut-chart"></i><span>{props.t("Proforma Reports")}</span></Link></li>
                      <li><Link to="/reports/invoices"><i className="bx bx-doughnut-chart"></i><span>{props.t("Invoice Report")}</span></Link></li>
                      <li><Link to="/reports/payroll"><i className="bx bx-doughnut-chart"></i><span>{props.t("Payroll Report")}</span></Link></li>
                      <li><Link to="/reports/wnotification"><i className="bx bx-doughnut-chart"></i><span>{props.t("WhatsApp Report")}</span></Link></li>
                      <li><Link to="/reports/no-order-clinets"><i className="bx bx-doughnut-chart"></i><span>{props.t("No Order Clients")}</span></Link></li>
                      <li><Link to="/reports/lmsd-report"><i className="bx bx-doughnut-chart"></i><span>{props.t("LMSD Reports")}</span></Link></li>
                      <li><Link to="/reports/genrated-invoices"><i className="bx bx-doughnut-chart"></i><span>{props.t("Generated Invoices")}</span></Link></li>
                      <li><Link to="/reports/invoice-summary"><i className="bx bx-doughnut-chart"></i><span>{props.t("Invoice Summary")}</span></Link></li>
                    </>
                  )}

                  {(isAdmin == "superadmin" ||
                    isAdmin == "admin" ||
                    isAdmin == "owner") && (
                      <>
                        <li className="menu-title">{props.t("Settings")}</li>
                        <li>
                          <Link to="/settings/company">
                            <i className="bx bx-shield-quarter"></i>
                            <span>{props.t("Company Settings")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/settings/notifications">
                            <i className="bx bx-station"></i>
                            <span>{props.t("Notifications")}</span>
                          </Link>
                        </li>

                        <li>
                          <Link to="/company/backup">
                            <i className="fas fa-cloud-download-alt"></i>
                            <span>{props.t("Backup")}</span>
                          </Link>
                        </li>
                      </>
                    )}
                </>
              )}
          </ul>
          <img
            src={pcs}
            alt="powered_by_catchysystem_technologies_pvt_ltd"
            style={{
              margin: "20px",
              width: "80%",
              borderTop: "2px solid #f4f4f4",
            }}
          />
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
